import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const StartQuizFilled = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();
	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0ZM17.2334 12.293C16.567 11.925 15.7503 12.4068 15.75 13.168V28.832C15.7503 29.5932 16.567 30.075 17.2334 29.707L31.415 21.875C32.1034 21.4946 32.1034 20.5054 31.415 20.125L17.2334 12.293Z'
				fill={color ? handleColorType(color, theme) : '#616161'}
			/>
		</svg>
	);
};
